export const THREE_MINUTES_MS = 180000;
export const ONE_MINUTE_MS = 60000;
export const ONE_SECOND_MS = 1000;
